/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const API_URL = 'https://knowledgemap-backend.azurewebsites.net/search';

export const fetchTopicData = async (topic, existingSessionId = null, parent_id="0", hierarchy= [{}]) => {
  try {
    // Use existing session ID if provided, otherwise generate new one
    const session_id = existingSessionId || uuidv4();

    const response = await axios.post(API_URL, {
      topic,
      session_id,
      parent_id,
      hierarchy,
    });

    // Return both the data and the session ID used
    return {
      ...response.data,
      session_id: response.data.session_id || session_id // Use the backend's session ID if provided, fallback to our generated one
    };
  } catch (error) {
    console.error('Error fetching topic data:', error);
    throw error;
  }
  };
